import React from 'react';
import { classNames } from 'helpers/style/classNames';
import useStyle from './containerTwoThirds.style';

export interface ContainerTwoThirdsProps {
  col1?: React.ReactNode;
  col2?: React.ReactNode;
  variant?: 'default' | 'dashboard' | 'reverse' | 'productSingle';
}

export const ContainerTwoThirds = ({
  col1,
  col2,
  variant = 'default'
}: ContainerTwoThirdsProps) => {
  const classes = useStyle();

  return (
    <div className={classNames([classes.root, classes[variant]])}>
      <div
        className={classNames(
          [],
          [
            { condition: variant === 'default', classe: classes.col1 },
            {
              condition: variant === 'dashboard',
              classe: classes.col1dashboard
            },
            { condition: variant === 'reverse', classe: classes.col1reverse },
            {
              condition: variant === 'productSingle',
              classe: classes.col1productSingle
            }
          ]
        )}
      >
        {col1}
      </div>
      <div
        className={classNames(
          [],
          [
            { condition: variant === 'default', classe: classes.col2 },
            {
              condition: variant === 'dashboard',
              classe: classes.col2dashboard
            },
            { condition: variant === 'reverse', classe: classes.col2reverse },
            {
              condition: variant === 'productSingle',
              classe: classes.col2productSingle
            }
          ]
        )}
      >
        {col2}
      </div>
    </div>
  );
};
